import { render, staticRenderFns } from "./copyright.vue?vue&type=template&id=24e4a8de&scoped=true&"
var script = {}
import style0 from "./copyright.vue?vue&type=style&index=0&id=24e4a8de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e4a8de",
  null
  
)

export default component.exports